import { computed, effect, inject, Injectable } from '@angular/core';
import { OrderApiResponseStateService } from './order-api-response-state.service';
import { BasePdResponseService } from './base-pd-response.service';
import { isVoiceProductType, OrderFlowType } from '../../../../../models/order/order.model';

@Injectable({ providedIn: 'root' })
export class VoiceProductResponseService extends BasePdResponseService {
    private orderApiResponseStateService = inject(OrderApiResponseStateService);
    override productResponse = computed(() => this.orderApiResponseStateService.voiceProductDetailsData());

    getProductComponent() {
        const pdResponse = this.productResponse();
        return pdResponse?.Components?.Component.find(c => isVoiceProductType(c.ProductType));
    }

    constructor() {
        super();
        effect(() => {
            const pdResponse = this.productResponse();
            if (pdResponse) {
                this.setupCustomizations();
            } else {
                this.customizations.set([]);
            }
        });
    }

    override setupCustomizations() {
        const productComponent = this.getProductComponent();
        if (!productComponent) {
            this.customizations.set([]);
            return;
        }

        const customizations = this.flattenCustomizations(productComponent, OrderFlowType.Voice);
        customizations.sort((a, b) => a.customization.Seq - b.customization.Seq);
        this.customizations.set(customizations);
    }
}
